import React from 'react';
import { FileText, Folder } from 'lucide-react';

import type { FileEntry } from '@/types/SixDetail.types';

interface DragMovePreviewProps {
  item: FileEntry;
  totalCount: number;
}

function DragMovePreview({ item, totalCount }: DragMovePreviewProps): React.ReactElement {
  const Icon = item.kind === 'folder' ? Folder : FileText;
  const iconColor = item.kind === 'folder' ? 'text-primary' : 'text-muted-foreground';

  return (
    <div className="flex items-center gap-2 rounded-lg border border-primary/30 bg-background px-3 py-2 shadow-lg">
      <Icon className={`h-4 w-4 flex-shrink-0 ${iconColor}`} />
      <span className="truncate text-sm font-medium text-foreground max-w-[200px]">
        {item.name}
      </span>
      {totalCount > 1 && (
        <span className="ml-1 inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-primary px-1.5 text-xs font-semibold text-primary-foreground">
          +{totalCount - 1}
        </span>
      )}
    </div>
  );
}

export default DragMovePreview;
